import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Checkbox,
  Container,
  Divider,
  Grid,
  Snackbar,
  Table,
  TableCell,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  TextField,
  createTheme,
  Button,
  TablePagination,
  TableSortLabel,
} from '@material-ui/core';
import { Autocomplete } from '@mui/material';
import Alert from 'src/components/Alert';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import { useTheme } from '@mui/material/styles';

import trLocale from 'date-fns/locale/tr';

import { Stack } from '@mui/material';
import axios from 'src/utils/axios';

import SearchIcon from '@mui/icons-material/Search';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PrintIcon from '@mui/icons-material/Print';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import ExcelFileCreator from 'src/components/ExcelFileCreator';


const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EmployeeMultipleUsedIdReport() {
  const useStyles = makeStyles(theme => ({
    root: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },
    rootlist: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      position: 'relative',
      overflow: 'auto',
      maxHeight: 550
    },
    rootlistsag: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      position: 'relative',
      overflow: 'auto',
      maxHeight: 500
    },

    cardBolum: {
      maxHeight: 700,
      minHeight: 700,
      width: '100%'
    },
    table: {
      minWidth: 650
    },
    content: {
      minHeight: 550
    },
    chatSection: {
      width: '100%'
    },
    avatar: {
      cursor: 'pointer',
      width: 40,
      height: 40
    },
    headBG: {
      backgroundColor: '#e0e0e0'
    },
    borderRight500: {
      borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
      overflowY: 'auto'
    },
    button: {
      margin: theme.spacing(1)
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    actionsCCFile: {
      justifyContent: 'flex-end'
    },
    responsiveContainer: {
      marginTop: theme.spacing(3),
      [theme.breakpoints.between('md', 'lg')]: {
        maxHeight: '70vh',
        overflowX: 'hidden',
        overflowY: 'scroll'
      },
      [theme.breakpoints.down('sm')]: {
        maxHeight: '60vh',
        overflow: 'scroll'
      }
    },
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: 10,
      borderRadius: 10,
    },
    switch_track: {
      backgroundColor: "#263238",
    },
    switch_base: {
      color: '#FF9800',
      "&.Mui-disabled": {
        color: '#FF9800'
      },
      "&.Mui-checked": {
        color: "#FF9800"
      },
      "&.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#263238",
      }
    },
    switch_primary: {
      "&.Mui-checked": {
        color: "#263238",
      },
      "&.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#263238",
      },
    },

  }));

  const theme = useTheme();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const SessionUser = getUser();

  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [SelectedBirim, setSelectedBirim] = React.useState([]);

  const [employeeReportData, setEmployeeReportData] = React.useState([]);
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(10);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
  const selectAllIcon = <PlaylistAddCheckIcon fontSize="small" />;

  const SelectAllOption = { BirimKodu: 0, Dsc: 'Tümü' };
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('ElemanNo');
  const sortedRows = stableSort(employeeReportData, getComparator(order, orderBy));

  useEffect(() => {
    getBolgeAdiKoduData();
  }, []);






  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      setBolgeAdiKodu(response?.data);
    })

  }

  const getBirimData = (BirimKodu) => {
    if (!BirimKodu || BirimKodu.length < 1) {
      setBirimData([]);
    } else {
      setLoading(true);
      axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
        setBirimData([SelectAllOption, ...response.data]);
        setLoading(false);
      });
    }
  }


  const getReport = () => {
    setLoading(true);
    setEmployeeReportData([]);
    const birimKoduQuery = !SelectedBirim || SelectedBirim.length < 1 || SelectedBirim.find((x) => x.BirimKodu == 0) ? '0'
      : SelectedBirim?.map(x => x.BirimKodu).join("&BirimKodu=");
    const bolgeKoduQuery = !selectedbolgeAdiKodu || selectedbolgeAdiKodu.length < 1 || selectedbolgeAdiKodu.find((x) => x.BirimKodu == 0) ? '0'
      : selectedbolgeAdiKodu?.map(x => x.BirimKodu).join("&BolgeKodu=");
    axios.get(`GetEmployeeMultipleUsedIdReport?BolgeKodu=${bolgeKoduQuery}&BirimKodu=${birimKoduQuery}`).then((response) => {
      setEmployeeReportData(response.data);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
    });
  }

  function handleChangePage(event, newpage) {
    setpg(newpage);
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const clearAllInputs = () => {
    setSelectedbolgeAdiKodu([]);
    setSelectedBirim([]);
    setEmployeeReportData([]);
    setpg(0);
    setrpg(10);
  }

  const handleExportClick = () => {
    var exportData = [];
    sortedRows.map((item) => {
      exportData.push({
        'Servis Kodu': item.ServisKodu,
        'Servis Adı': item.Servis,
        'Eleman No': item.ElemanNo,
        'TC Kimlik No': item.TC,
        'Ad': item.AD,
        'Soyad': item.SOYAD,
        'Çalışan Tip': item.Tip
      })
    })
    ExcelFileCreator(exportData, `Çalışan Çoklanan TC Raporu`);
  };

  const renderOption = (props, option, { selected }) => (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      {option.Dsc}
    </li>
  );




  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
        ></Alert>
      </Snackbar>
      <Container className={classes.container1} maxWidth="xl">
        <Card>
          <CardHeader title="Çalışan Çoklanan TC" />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                  <Button
                    className={classes.action}
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      getReport();
                    }}
                  >
                    ARA
                    <SearchIcon style={{ marginLeft: '5px' }} />
                  </Button>
                  <Button
                    className={classes.action}
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      handleExportClick();
                    }}
                    style={{ marginRight: '5px' }} // Add margin to the right
                  >
                    YAZDIR
                    <PrintIcon style={{ marginLeft: '5px' }} />
                  </Button>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={12} lg={6} >
                <Autocomplete
                  multiple
                  limitTags={1}
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedbolgeAdiKodu}
                  options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    setSelectedbolgeAdiKodu(newValue);
                    var bolgeKodu = newValue?.find(x => x.BirimKodu == 0) ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                    getBirimData(bolgeKodu);
                    setSelectedBirim([]);
                  }}
                  renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={6}>
                <Autocomplete
                  multiple
                  limitTags={1}
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={SelectedBirim}
                  options={BirimData.length > 0 ? BirimData : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    newValue?.find(x => x.Id == -1) ? setSelectedBirim(BirimData) : setSelectedBirim(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}

                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TableContainer >
                  <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead style={{ overflowWrap: 'break-word' }}>
                      <TableRow>
                        <TableCell
                          align="left"
                          sortDirection={orderBy === 'ServisKodu' ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === 'ServisKodu'}
                            direction={orderBy === 'ServisKodu' ? order : 'asc'}
                            onClick={() => { handleRequestSort('ServisKodu') }}
                          >
                            Servis Kodu
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          align="left"
                          sortDirection={orderBy === 'Servis' ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === 'Servis'}
                            direction={orderBy === 'Servis' ? order : 'asc'}
                            onClick={() => { handleRequestSort('Servis') }}
                          >
                            Servis Adı
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          align="left"
                          sortDirection={orderBy === 'ElemanNo' ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === 'ElemanNo'}
                            direction={orderBy === 'ElemanNo' ? order : 'asc'}
                            onClick={() => { handleRequestSort('ElemanNo') }}
                          >
                            Eleman No
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          align="left"
                          sortDirection={orderBy === 'TC' ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === 'TC'}
                            direction={orderBy === 'TC' ? order : 'asc'}
                            onClick={() => { handleRequestSort('TC') }}
                          >
                            TC Kimlik No
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          align="left"
                          sortDirection={orderBy === 'AD' ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === 'AD'}
                            direction={orderBy === 'AD' ? order : 'asc'}
                            onClick={() => { handleRequestSort('AD') }}
                          >
                            Ad
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          align="left"
                          sortDirection={orderBy === 'SOYAD' ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === 'SOYAD'}
                            direction={orderBy === 'SOYAD' ? order : 'asc'}
                            onClick={() => { handleRequestSort('SOYAD') }}
                          >
                            Soyad
                          </TableSortLabel>
                        </TableCell>
                        <TableCell
                          align="left"
                          sortDirection={orderBy === 'Tip' ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === 'Tip'}
                            direction={orderBy === 'Tip' ? order : 'asc'}
                            onClick={() => { handleRequestSort('Tip') }}
                          >
                            Tip
                          </TableSortLabel>
                        </TableCell>
                        <TableCell align="left" />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedRows.length > 0 && sortedRows.slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                        <TableRow
                          key={row.Id}
                        >
                          <TableCell align="left">{row.ServisKodu || "-"}</TableCell>
                          <TableCell align="left">{row.Servis || "-"}</TableCell>
                          <TableCell align="left">{row.ElemanNo || "-"}</TableCell>
                          <TableCell align="left">{row.TC || "-"}</TableCell>
                          <TableCell align="left">{row.AD || "-"}</TableCell>
                          <TableCell align="left">{row.SOYAD || "-"}</TableCell>
                          <TableCell align="left">{row.Tip || "-"}</TableCell>
                          <TableCell align="left" />
                        </TableRow>
                      ))}

                    </TableBody>

                  </Table>
                </TableContainer>
                {sortedRows.length > 0 &&
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={sortedRows.length}
                    rowsPerPage={rpg}
                    page={pg}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                }
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Page >
  );
}
export default EmployeeMultipleUsedIdReport;
